var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-link',{attrs:{"href":_vm.link,"underline":false,"target":_vm.title,"title":_vm.title}},[_c('el-avatar',{style:({ opacity: _vm.opacity }),attrs:{"shape":"square","size":_vm.size,"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }